/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Margin = {
    type: Margin.type;
    top: number;
    bottom: number;
    left: number;
    right: number;
}

export namespace Margin {

    export enum type {
        WALL = 'WALL',
        ROOF = 'ROOF',
        PARENT_OPTION = 'PARENT_OPTION',
        OPTION = 'OPTION',
    }


}
